import React from 'react';

import { Link, useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';

import { FiHome, FiCreditCard, FiUser, FiUsers, FiLogOut, FiSettings } from 'react-icons/fi';

import { IoScanOutline } from 'react-icons/io5';

import './Sidebar.css';



const Sidebar = () => {

  const { user, logout } = useAuth();

  const location = useLocation();

  const navigate = useNavigate();



  const handleLogout = async () => {

    await logout();

    navigate('/login');

  };



  if (!user) {

    return null;

  }



  const menuItems = [

    { path: '/home', icon: FiHome, label: 'Home' },

    { path: '/my-card', icon: FiCreditCard, label: 'My Card' },

    { path: '/scan', icon: IoScanOutline, label: 'Scan' },

    { path: '/contacts', icon: FiUsers, label: 'Contacts' },

    { path: '/profile', icon: FiUser, label: 'Account' },

    { path: '/settings', icon: FiSettings, label: 'Settings' },

  ];



  return (

    <div className="sidebar">

      <div className="sidebar-header">

        <img src="/logo.png" alt="OMNI" className="sidebar-logo" />

        <h1 className="sidebar-brand">OMNI</h1>

      </div>



      <div className="sidebar-user">

        <div className="sidebar-avatar">

          <FiUser size={24} />

        </div>

        <div className="sidebar-user-info">

          <div className="sidebar-user-name">

            {user.first_name} {user.last_name}

          </div>

          <div className="sidebar-user-role">{user.job_title || 'Professional'}</div>

        </div>

      </div>



      <nav className="sidebar-nav">

        {menuItems.map((item) => {

          const Icon = item.icon;

          const isActive = location.pathname === item.path;

          

          return (

            <Link

              key={item.path}

              to={item.path}

              className={`sidebar-link ${isActive ? 'active' : ''}`}

            >

              <Icon size={20} />

              <span>{item.label}</span>

            </Link>

          );

        })}

      </nav>



      <div className="sidebar-footer">

        <button onClick={handleLogout} className="sidebar-logout">

          <FiLogOut size={20} />

          <span>Logout</span>

        </button>

      </div>

    </div>

  );

};



export default Sidebar;

